import React, { useState, useEffect } from 'react';
import { Button, Input } from '../../components/ui/Forms';
import SafeIcon from '../../common/SafeIcon';
import supabase from '../../supabase/supabase';

export default function SmtpPanel({ profile }) {
  const [smtp, setSmtp] = useState({ host: '', port: '', smtp_user: '', smtp_pass: '', from_email: '' });
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => { fetchSmtp(); }, []);

  const fetchSmtp = async () => {
    const { data } = await supabase.from('smtp_settings_20240520').select('*').single();
    if (data) setSmtp(data);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { error } = await supabase.from('smtp_settings_20240520').upsert({ ...smtp, user_id: profile.id });
    if (!error) {
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    }
    setLoading(false);
  };

  return (
    <div className="bg-white p-8 rounded-[32px] shadow-sm border border-slate-100 h-full">
      <div className="flex items-center gap-3 mb-8">
        <div className="p-2.5 bg-indigo-50 text-indigo-600 rounded-2xl">
          <SafeIcon name="Server" />
        </div>
        <div>
          <h2 className="text-xl font-bold text-slate-800">SMTP Gateway</h2>
          <p className="text-xs text-slate-500 font-medium">Outbound email configuration</p>
        </div>
      </div>

      <form onSubmit={handleSave} className="space-y-5">
        <div className="grid grid-cols-3 gap-4">
          <div className="col-span-2">
            <Input label="Host" value={smtp.host} onChange={e => setSmtp({ ...smtp, host: e.target.value })} required placeholder="mail.example.com" />
          </div>
          <Input label="Port" type="number" value={smtp.port} onChange={e => setSmtp({ ...smtp, port: e.target.value })} required placeholder="587" />
        </div>
        <Input label="Username / Email" value={smtp.smtp_user} onChange={e => setSmtp({ ...smtp, smtp_user: e.target.value })} required />
        <Input label="Password" type="password" value={smtp.smtp_pass} onChange={e => setSmtp({ ...smtp, smtp_pass: e.target.value })} required />
        <Input label="From Email Address" value={smtp.from_email} onChange={e => setSmtp({ ...smtp, from_email: e.target.value })} required placeholder="noreply@subsifttoucan.com" />
        
        <div className="pt-6">
          <Button type="submit" disabled={loading} className="w-full h-12 rounded-2xl">
            {loading ? 'Verifying...' : 'Update Configuration'}
          </Button>
          {saved && (
            <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="text-teal-600 text-sm font-bold text-center mt-3 flex items-center justify-center gap-2">
              <SafeIcon name="CheckCircle" className="w-4 h-4" /> Settings Synchronized
            </motion.p>
          )}
        </div>
      </form>
    </div>
  );
}